export default __webpack_public_path__ + "static/media/image3.297cf066.jpg";